export default {
    isMobile: false,
    lang: 'eng',
    languageActive: false,
    translation: {
        menu: {},
        showreel: {
            top: '',
            bottom: ''
        }
    }
};